import React, { useState } from 'react';
import I18N from '@leverege/i18n';
import Molten from '@leverege/molten';
import { Dialog, Flex, Pane, Content, Button, Text, Toast } from '@leverege/ui-elements';
import { LoadingScreen } from '@leverege/molten/screens';
import { Attributes } from '@leverege/ui-attributes';
import { TitleBar } from '@leverege/ui-plugin';
import { GlobalState } from '@leverege/ui-redux';
import { isPositionRequestableByOperationStateAndConfig, isPositionRequestableByStateConfigVersionNumber } from './Util';
import S from './PositionRequestDialog.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('recovr.locator.positionRequest.PositionRequestDialog');
export default function PositionRequestDialog(props) {
  const {
    show,
    onClose,
    locator
  } = props;
  const [loading, setLoading] = useState(false);
  async function requestPostion(locator) {
    await GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      try {
        const systemId = Molten.getConfig('api/systemId');
        const companyId = Attributes.get('locator.company', 'locator', locator);
        const locationId = Attributes.get('locator.location', 'locator', locator);
        const locatorId = locator.id;
        let nApi;
        if (companyId && locationId) {
          nApi = api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).grp('locators').obj(`${locatorId}`);
        } else if (companyId) {
          nApi = api.interface(systemId, 'company').obj(companyId).grp('locators').obj(locatorId);
        } else {
          nApi = api.interface(systemId, 'location').obj(locationId).grp('locators').obj(locatorId);
        }
        await nApi.srv('recovr').post('requestPosition');
        Toast.success(t('success'));
      } catch (err) {
        console.error(err);
        Toast.error([t('error'), err?.message]);
      }
    });
  }
  const onOkay = async () => {
    setLoading(true);
    await requestPostion(locator);
    setLoading(false);
    onClose();
  };
  let disabled, disabledMessage;
  if (!isPositionRequestableByStateConfigVersionNumber(locator) && !isPositionRequestableByOperationStateAndConfig(locator)) {
    disabled = true;
    disabledMessage = t('disabledMessage');
  }
  return /*#__PURE__*/_jsx(Dialog, {
    show: show,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(Content, {
      relative: true,
      children: [/*#__PURE__*/_jsx(Content.Header, {
        variant: "dialogHeader",
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: "dialogTitle",
          title: t('title'),
          icon: tIcon('titleIcon')
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        variant: "dialogBody",
        children: loading ? /*#__PURE__*/_jsx(Pane, {
          children: /*#__PURE__*/_jsx(LoadingScreen, {
            title: t('loadingTitle')
          })
        }) : /*#__PURE__*/_jsx(Flex, {
          variant: "colM",
          children: disabled ? /*#__PURE__*/_jsx(Pane, {
            className: S.messageContainer,
            children: /*#__PURE__*/_jsxs(Flex, {
              variant: "row",
              align: "start",
              children: [/*#__PURE__*/_jsx(Text, {
                icon: "https://recovr-ui-assets.storage.googleapis.com/system-info.png",
                className: S.messageIcon
              }), /*#__PURE__*/_jsx(Text, {
                className: S.messageText,
                children: disabledMessage
              })]
            })
          }) : /*#__PURE__*/_jsx(Text, {
            className: S.messageText,
            children: t('enabledMessage')
          })
        })
      }), /*#__PURE__*/_jsxs(Content.Footer, {
        variant: "dialogFooter",
        layout: "flex:rowMEnd",
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: loading,
          variant: "secondary",
          onClick: onClose,
          children: t('cancel')
        }), /*#__PURE__*/_jsx(Button, {
          disabled: loading || disabled,
          variant: "primary",
          onClick: onOkay,
          children: t('confirm')
        })]
      })]
    })
  });
}